import client from './client';

export interface RiskScore {
  company_id: string;
  score: number;
  size_score: number;
  freshness_score: number;
  state_score: number;
  band: 'low' | 'medium' | 'high';
  explanation: string;
}

export async function getRiskScore(): Promise<RiskScore> {
  const r = await client.get<RiskScore>('/risk/risk-score');
  return r.data;
}

export async function carryForward(fromYear: number, toYear: number): Promise<{ copied_papers: number }> {
  const r = await client.post<{ copied_papers: number }>('/risk/carry-forward', {
    from_year: fromYear,
    to_year: toYear,
  });
  return r.data;
}
